export default __webpack_public_path__ + "static/media/git.464bf8f3.svg";